<div class="how-to-upload" [class.isFlashImport]="isFlashImport">
  <div class="header">
    <h1 class="title">{{ title }}</h1>
    <div class="tutorial-button">
      <qa-button
        label="dashboardNew.liveEventCardDefault.watchTutorial"
        (submitted)="openHelp()"
        [showIconAtEnd]="true"
        icon="play_circle"
      ></qa-button>
    </div>
  </div>
  <div class="links flex-row">
    <div class="excel">
      <a
        download
        class="flex-row flex-align-items-center flex-justify-content-center"
        [href]="uploadAreaParameters?.excel"
      >
        <mat-icon>download</mat-icon>
        <div [innerHTML]="'csvImports.excelFormat' | translate"></div>
      </a>
    </div>
    <div class="csv">
      <a
        download
        class="flex-row flex-align-items-center flex-justify-content-center"
        [href]="uploadAreaParameters?.csv"
      >
        <mat-icon>download</mat-icon>
        <div [innerHTML]="'csvImports.csvFormat' | translate"></div>
      </a>
    </div>
  </div>
  @if (showInfoBanner) {
  <div class="info-banner">
    <div class="banner-content">
      <mat-icon>info</mat-icon>
      <span class="text">{{ 'csvImports.aiAssistantBanner' | translate }}</span>
    </div>
    <mat-icon class="close-icon" (click)="showInfoBanner = false"
      >close</mat-icon
    >
  </div>
  }
  <div class="upload-area">
    <div class="card">
      @if (selectedFile) {
      <div class="file-preview-chip">
        <div class="file-info">
          <div class="file-icon-bg">
            <mat-icon>insert_drive_file</mat-icon>
          </div>
          <div class="file-details">
            <span class="file-name">{{ selectedFile.name }}</span>
            <span class="file-size">{{
              formatFileSize(selectedFile.size)
            }}</span>
          </div>
        </div>
        <a class="remove-link" (click)="removeFile()">{{
          'csvImports.remove' | translate
        }}</a>
      </div>
      } @else {
      <div class="new-upload-container" (click)="drop.showFileSelector()">
        <mat-icon class="upload-icon">insert_drive_file</mat-icon>
        <div
          class="upload-text"
          [innerHTML]="'csvImports.uploadOrBrowse' | translate"
        ></div>
      </div>
      }

      <div class="divider">
        <span class="divider-text">{{
          'csvImports.insertDirectly' | translate
        }}</span>
      </div>

      <div class="drag-drop-table" (dragenter)="enterDrag()">
        <ng-scrollbar #scrollable [class.ps-show-always]="false" track="all">
          <table mat-table [dataSource]="tableData">
            @for (col of columnNames; track $index; let i = $index) {
            <ng-container [matColumnDef]="col" [sticky]="col === 'number'">
              <th mat-header-cell *matHeaderCellDef>
                @if (col === 'action') {
                {{ 'csvImports.action' | translate }}
                } @else if (col === 'number') { # } @else {
                {{ topRow.split(';')[i - 1] }}
                }
              </th>
              <td
                mat-cell
                *matCellDef="let element; let rIdx = index"
                id="csv-table-cell-{{ element.number }}-{{ i }}"
                (keydown)="onKeyDown($event, i, element.number)"
                (click)="
                  col === 'number' || col === 'action' ? null : editCell($event)
                "
                (blur)="
                  col === 'number' || col === 'action'
                    ? null
                    : saveCell($event, element, col)
                "
                (paste)="
                  col === 'number' || col === 'action'
                    ? null
                    : onPaste($event, element.number, i)
                "
                [class.placeholder]="!element[col] && i === 1 && rIdx === 0"
                [class.action-cell]="col === 'action'"
              >
                @if (col === 'action') {
                <mat-icon class="delete-icon" (click)="removeRow(rIdx)"
                  >delete_outline</mat-icon
                >
                } @else if (!element[col] && i === 1 && rIdx === 0) {
                <div class="placeholder-text">
                  {{ 'csvImports.copyPlaceholder' | translate }}
                </div>
                } @else {
                {{ element[col] }}
                }
              </td>
            </ng-container>
            }

            <tr
              mat-header-row
              *matHeaderRowDef="columnNames; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames"></tr>
          </table>
        </ng-scrollbar>
        <div class="table-footer" (click)="addRow()">
          <mat-icon>add</mat-icon>
          {{ 'csvImports.addLine' | translate }}
        </div>

        <div
          class="dropzone"
          #drop
          ngx-dropzone
          [multiple]="false"
          [class.isVisible]="isDragging"
          (dragleave)="leaveDrag()"
          [accept]="'.csv, .xlsx'"
          (change)="onSelectFile($event.addedFiles)"
          data-cy="ngxDropzone"
        >
          <ngx-dropzone-label>
            <div class="drag-content">
              <div class="drag-drop">
                {{ 'csvImports.dragDrop' | translate }}
              </div>
              <span class="file-format">{{
                'csvImports.fileFormat' | translate
              }}</span>
            </div>
          </ngx-dropzone-label>
        </div>
      </div>

      <div class="tip-text">
        {{ 'csvImports.tipAssistant' | translate }}
      </div>
    </div>
  </div>

  <div class="btn-actions">
    <qa-button
      label="common.button.cancel"
      (submitted)="cancelConfirm()"
    ></qa-button>
    <qa-button
      [disabled]="!isReady()"
      [isRaisedButton]="true"
      label="common.button.next"
      data-cy="next"
      (submitted)="next()"
    ></qa-button>
  </div>
</div>
